import { Grid } from "@mui/material"
import React, { useEffect } from "react"
import ReportFormSectionDivider from "Pages/ReportsAlerts/Reports/@components/FormDrawer/SectionDivider"
import { ReportGenerateSwitch, ReportLimitHoursField } from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import ReportExtraCategoriesField from "Pages/ReportsAlerts/Reports/Extra/Page/Drawer/Sections/ExportFilters/Category"
import ReportExtrasAcrissField from "Pages/ReportsAlerts/Reports/Extra/Page/Drawer/Sections/ExportFilters/Acriss"
import { AppAntSwitch } from "@components"
import { reportFormData, useExtrasAcriss } from "Pages/ReportsAlerts/Reports/@signals"

export default function ReportFormDrawerExportFiltersSection() {

	return <Grid container spacing={2}>
		<Grid item xs={3} data-tour-id="tour-export-filters">
			<ReportFormSectionDivider title="Filters for Excel export & Generation" icon="sliders"/>
		</Grid>
		<Grid item xs={9}/>
		<Grid item xs={8}>
			<AcrissCategorySwitch/>
		</Grid>
		<Grid item xs={4}/>
		<Grid item xs={1}>
			<ReportLimitHoursField/>
		</Grid>
		<Grid item xs={1}>
			<ReportGenerateSwitch/>
		</Grid>
	</Grid>
}


function AcrissCategorySwitch() {

	useEffect(() => {
		useExtrasAcriss.value = !!reportFormData.peek().filterAcriss
	}, [])

	return <Grid container spacing={2}>
		<Grid item xs={4}>
			{useExtrasAcriss.value ? <ReportExtrasAcrissField/> : <ReportExtraCategoriesField/>}
		</Grid>
		<Grid item xs={8}>
			<AppAntSwitch
				checked={useExtrasAcriss.value}
				onChange={e => useExtrasAcriss.value = e.target.checked}
				trueText="Acriss"
				falseText="Categories"
			/>
		</Grid>
	</Grid>
}
